/* Progressive enhancement: thumbnails, touch scrolling and full-image viewing. */
(() => {
  'use strict';
  if (window.nusvivaProductGalleryReady) return;
  window.nusvivaProductGalleryReady = true;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mount(gallery) {
    if (gallery.dataset.nvGalleryReady) return;
    gallery.dataset.nvGalleryReady = 'true';
    const viewport = gallery.querySelector('[data-nv-gallery-viewport]');
    const slides = Array.from(gallery.querySelectorAll('[data-nv-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-nv-gallery-thumbnail]'));
    const status = gallery.querySelector('[data-nv-gallery-status]');
    if (!viewport || !slides.length) return;
    let active = 0;
    let frame = 0;
    function update(index) {
      active = Math.max(0, Math.min(index, slides.length - 1));
      thumbnails.forEach((thumbnail, i) => {
        if (i === active) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });
      if (status) status.textContent = `Image ${active + 1} of ${slides.length}`;
    }
    function select(index) {
      update(index);
      const offset = slides[active].getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
      viewport.scrollTo({ left: offset, behavior: reducedMotion() ? 'auto' : 'smooth' });
    }
    thumbnails.forEach((thumbnail, i) => {
      thumbnail.addEventListener('click', event => { event.preventDefault(); select(i); });
      thumbnail.addEventListener('keydown', event => {
        let next = i;
        if (event.key === 'ArrowRight') next = Math.min(i + 1, slides.length - 1);
        else if (event.key === 'ArrowLeft') next = Math.max(i - 1, 0);
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = slides.length - 1;
        else return;
        event.preventDefault();
        select(next);
        thumbnails[next].focus({ preventScroll: true });
      });
    });
    viewport.addEventListener('keydown', event => {
      if (event.target !== viewport) return;
      let next = active;
      if (event.key === 'ArrowRight') next += 1;
      else if (event.key === 'ArrowLeft') next -= 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = slides.length - 1;
      else return;
      event.preventDefault(); select(next);
    });
    viewport.addEventListener('scroll', () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = 0;
        const left = viewport.getBoundingClientRect().left;
        let closest = 0; let distance = Infinity;
        slides.forEach((slide, i) => {
          const delta = Math.abs(slide.getBoundingClientRect().left - left);
          if (delta < distance) { distance = delta; closest = i; }
        });
        update(closest);
      });
    }, { passive: true });
    update(0);
    if (!('HTMLDialogElement' in window)) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'nv-product-image-viewer';
    dialog.setAttribute('aria-label', 'Enlarged product image');
    const toolbar = document.createElement('div');
    toolbar.className = 'nv-product-image-viewer__toolbar';
    const original = document.createElement('a');
    original.textContent = 'Open full-size image'; original.target = '_blank'; original.rel = 'noopener';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = 'Close'; close.setAttribute('aria-label', 'Close enlarged image');
    const enlarged = document.createElement('img');
    enlarged.className = 'nv-product-image-viewer__image';
    toolbar.append(original, close); dialog.append(toolbar, enlarged); gallery.append(dialog);
    let opener = null;
    gallery.querySelectorAll('[data-nv-gallery-enlarge]').forEach(link => {
      link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); opener = link;
        enlarged.src = link.href; enlarged.alt = link.querySelector('img')?.alt || 'Product image';
        original.href = link.href; dialog.showModal(); close.focus({ preventScroll: true });
      });
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus({ preventScroll: true }); });
  }
  function initialize(root = document) { root.querySelectorAll('[data-nv-product-gallery]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
